document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initAngles();
  initProductoVariantes();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initCountUp() {
  var nums = document.querySelectorAll('.mt-count');
  if (!nums.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.dataset.target || '0');
        var decimals = el.dataset.decimals ? parseInt(el.dataset.decimals, 10) : 0;
        var suffix = el.dataset.suffix || '';
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.textContent = value.toFixed(decimals) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  nums.forEach(function (el) { io.observe(el); });
}

function initAngles() {
  var galleries = document.querySelectorAll('[data-mt-angles]');
  galleries.forEach(function (gallery) {
    var main = gallery.querySelector('[data-mt-angles-main]');
    var thumbs = gallery.querySelectorAll('[data-mt-angles-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-mt-angles-thumb');
        var alt = thumb.getAttribute('data-alt') || '';
        main.style.opacity = '0';
        setTimeout(function () {
          main.setAttribute('src', src);
          main.setAttribute('alt', alt);
          main.style.opacity = '1';
        }, 180);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
}

function initProductoVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var variantsJson = form.querySelector('[data-mt-variants-json]');
  if (!variantsJson) return;
  var variants = JSON.parse(variantsJson.textContent);
  var selects = form.querySelectorAll('[data-mt-option-select]');
  var idInput = form.querySelector('[data-mt-variant-id]');
  var priceEl = document.querySelector('[data-mt-price-now]');
  var priceOldEl = document.querySelector('[data-mt-price-old]');
  var submitBtn = form.querySelector('[data-mt-submit]');

  function currentSelection() {
    var sel = [];
    selects.forEach(function (s) { sel.push(s.value); });
    return sel;
  }

  function findVariant(selection) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selection[i]; });
    });
  }

  function moneyFormat(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function update() {
    var variant = findVariant(currentSelection());
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = moneyFormat(variant.price);
    if (priceOldEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceOldEl.textContent = moneyFormat(variant.compare_at_price);
        priceOldEl.style.display = '';
      } else {
        priceOldEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtn.getAttribute('data-label-disponible');
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-label-agotado');
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });
  update();
}
